export const secondsToTimeString = (totalSeconds: number): string => {
  // Calculate hours, minutes, and seconds
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Format the time string
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  // Combine the parts into 'HH:MM:SS' format
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};
